import ReactSvgIcon from "../UIElements/ReactSvgIcon";
import { ReactComponent as DownloadIcon } from "../../public/icons/DownloadIcon.svg";
import { DocumentCardItem, TabMenu } from "../../types";
import LibraryDocumentLayout from "./LibraryDocumentLayout/LibraryDocumentLayout";
import DocumentCardsList from "./DocumentCardsList/DocumentCardsList";
import { _downloadLibraryDocument } from "../../helpers";
import { useCallback, useEffect, useMemo, useState } from "react";
import { LibraryDocumentItemType } from "../../types";
import { getLibraryDocuments } from "../../services";
import { Box, Typography } from "@mui/material";

export default function LibraryDocument() {
    const allKey = "tous";
    const [libraryDocuments, setLibraryDocuments] = useState<
        LibraryDocumentItemType[]
    >([]);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const filterData = (query: string, data: any) => {
        if (!query) {
            return data;
        } else {
            return data.filter((d: any) =>
                d.name.toLowerCase().includes(query.toLocaleLowerCase())
            );
        }
    };

    const filterByCategory = (category: string, data: any) => {
        if (category === allKey) {
            return data;
        }
        return data.filter((d: any) => d.category === category);
    };

    const [searchQuery, setSearchQuery] = useState("");

    const categorisTabMenu: TabMenu[] = [
        {
            key: allKey,
            name: "Tous",
        },
    ].concat(
        libraryDocuments
            .map((lb: any) => {
                return { key: lb.category, name: lb.category };
            })
            .filter(
                (lb: any, index: number, self: TabMenu[]) =>
                    self.findIndex((o) => o.key === lb.key) === index
            )
    );

    const [activeTab, setActiveTab] = useState<string>(categorisTabMenu[0].key);

    const dataFilteredByCategory = filterByCategory(
        activeTab,
        libraryDocuments
    );

    const dataFiltered = filterData(searchQuery, dataFilteredByCategory);

    const extractDocumentName = (url: string): string => {
        const indexLastSlash = url.lastIndexOf("/");
        const fileName = url.substring(indexLastSlash + 1, url.length);
        return fileName;
    };

    const documentCardItems: DocumentCardItem[] = useMemo(() => {
        return dataFiltered.map((ld: any) => {
            const { id, name, year, url } = ld;
            return {
                id,
                year,
                name,
                actions: {
                    download: {
                        icon: (
                            <ReactSvgIcon
                                sx={{
                                    cursor: "pointer",
                                }}
                                onClick={async () => {
                                    await _downloadLibraryDocument(
                                        id,
                                        extractDocumentName(url)
                                    );
                                }}
                                ReactIcon={DownloadIcon}
                                reactIconProps={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                }}
                            />
                        ),
                    },
                },
            };
        });
    }, [dataFiltered]);

    const fetchLibraryDocuments = useCallback(async () => {
        const libDocsRes = await getLibraryDocuments();
        if (!libDocsRes.detail) {
            setLibraryDocuments(libDocsRes);
            setIsLoading(true);
        }
    }, []);

    useEffect(() => {
        fetchLibraryDocuments();
    }, [fetchLibraryDocuments]);

    return (
        <LibraryDocumentLayout
            headerTitle={
                "Retrouvez ici tous les documents qui vont vous aider à compléter un dossier"
            }
            numberOfDocs={documentCardItems.length}
            setSearchQuery={setSearchQuery}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            tabsMenu={categorisTabMenu}
        >
            {dataFiltered.length ? (
                <DocumentCardsList documentCardItems={documentCardItems} />
            ) : isLoading ? (
                <Box>
                    <Typography
                        sx={{
                            color: "#023",
                            fontFamily: "Roboto",
                            fontSize: "1.125rem",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "normal",
                        }}
                    >
                        {"Vous n’avez aucun document."}
                    </Typography>
                </Box>
            ) : null}
        </LibraryDocumentLayout>
    );
}
